import { InjectionToken } from "@angular/core";

export const STATIC_FILTER_STATE_PROP = new InjectionToken<string>("STATIC_FILTER_STATE_PROP");
export const staticFilterStatePropProvider = {
    provide: STATIC_FILTER_STATE_PROP,
    useValue: "staticFilters",
};
